<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">申请记录</div>
            <div class="page-back" @click="toBack">返回</div>
        </div>
        <empty v-if="lists.length === 0" :type="2"/>
        <div v-else class="ship-list margin-top">
            <el-table
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%; border-radius: 10px">
                <el-table-column label="序号" prop="name">
                    <template slot-scope="scope">
                        <div class="flex justify-center">
                            {{ scope.$index + 1 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务名称" prop="onetitle">
                    <template slot-scope="scope">
                        <div class="table-name"> {{ scope.row.onetitle }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="服务分类" prop="twotitle">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{ scope.row.twotitle }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="add_time">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{ scope.row.add_time }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="add_time">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{ scope.row.status === 1 ? '处理中' : '已完成' }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {getServerRecord} from '@/api/member'
import {zhDate} from "../../../../utils/utils";

export default {
    components: {},
    name: "serviceRecord",
    data() {
        return {
            lists: [],
        }
    },
    created() {
        this.$emit('setIndex', [4], '申请记录')
        this.init()
    },
    computed: {},
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getServerRecord()
            if (_data.status === 200) {
                _data.data.map(item => {
                    item.add_time = zhDate(item.add_time * 1000)
                })
                this.lists = _data.data
            }
        },
        toBack() {
            this.$router.go(-1)
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .table-name{
        text-align: center;
    }
}

</style>